@if (
  {
    canResendOtp: canResendOtp(),
    expiresAt: expiresAt(),
    countdownSeconds: countdownSeconds()
  };
  as STATE
) {
  <p class="auth-countdown">
    @if (STATE.expiresAt) {
      @if (STATE.canResendOtp) {
        <p class="auth-countdown__text">
          Vous n'avez pas reçu le code ?
          <button
            type="button"
            (click)="onOtpResend()"
            class="auth-countdown__resend-btn"
          >
            Renvoyer le code de vérification
          </button>
        </p>
      } @else {
        Renvoyer un nouveau code dans :
        <countdown
          #countdown
          class="auth-countdown__countdown"
          [config]="{
            leftTime: STATE.countdownSeconds,
            format: 'mm:ss',
            notify: [10, 5, 1]
          }"
          (event)="onCountdownEvent($event)"
        />
      }
    }
  </p>
}
